import { FormBase } from 'core/components';
import moment from 'moment';
import validatorjs from 'validatorjs';

export default class ProductActivityForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
			validateOnChangeAfterSubmit: true,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'dateRangeStart',
					label: 'PRODUCTACTIVITYVIEW.LABEL.DATERANGESTART',
					rules: 'required',
				},
				{
					name: 'dateRangeEnd',
					label: 'PRODUCTACTIVITYVIEW.LABEL.DATERANGEEND',
				},
				{
					name: 'warehouseId',
					label: 'PRODUCTACTIVITYVIEW.LABEL.WAREHOUSE',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/ProductActivityForm.js